import "./App.css";
import { Canvas } from "@react-three/fiber";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import KUTE from "kute.js";
import Drone from "./Drone";
import { Suspense } from "react";
import Resume from "./Assets/Resume.pdf"
import { Environment, OrbitControls } from "@react-three/drei";
import MyLoader from "./Components/Loader/Loader"
import { useEffect } from "react";
import { gsap } from "gsap";
// import ScrambleTextPlugin from "gsap-trial/ScrambleTextPlugin";
import TextPlugin from "gsap/TextPlugin";

// var tween = KUTE.to("#svg1", { path: "#svg2" }).start();
function Loaded(){
  document.querySelector(".Loader").style.display = "none";
  document.querySelector(".App").style.display = "block";
}
function App() {
  useEffect(() => {
    setTimeout(Loaded, 500);
    // gsap.registerPlugin(ScrambleTextPlugin) 
    // gsap.to("#newClass", {
    //   scrambleText:{
    //     text:"The Tesla Club of Electrical and Electronics Engineering (EEE) department at NIT Goa proudly presents Prasang, an annual extravaganza that celebrates innovation, creativity, and the spirit of engineering excellence. Prasang is more than just an event; it's a platform that brings together budding engineers, industry experts, and enthusiasts to explore, learn, and showcase their skills. Be a part of this dynamic experience, where ideas flourish, collaborations thrive, and the joy of discovery is paramount. Save the date, gear up for an unforgettable journey, and we eagerly anticipate meeting you in Prasang!", 
    //     // chars:"lowerCase", 
    //     speed:0.3, 
    //     newClass:"orange",
    //      revealDelay:0.5, 
    //      tweenLength:false}})

  //   gsap.registerPlugin(TextPlugin)
  //   gsap.to("#newClass", {
  //     duration: 1, 
  //     text: "The Tesla Club of Electrical and Electronics Engineering (EEE) department at NIT Goa proudly presents Prasang, an annual extravaganza that celebrates innovation, creativity, and the spirit of engineering excellence. Prasang is more than just an event; it's a platform that brings together budding engineers, industry experts, and enthusiasts to explore, learn, and showcase their skills. Be a part of this dynamic experience, where ideas flourish, collaborations thrive, and the joy of discovery is paramount. Save the date, gear up for an unforgettable journey, and we eagerly anticipate meeting you in Prasang!"
  //   });
  }, []);
  return (
    <>
    <MyLoader></MyLoader>
    <div className="App">
      <Navbar></Navbar>
      {/* <Canvas>
    <ambientLight intensity={Math.PI / 2} />
    <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} decay={0} intensity={Math.PI} />
    <pointLight position={[-10, -10, -10]} decay={0} intensity={Math.PI} />
    <Box position={[-1.2, 0, 0]} />
    <Box position={[1.2, 0, 0]} />
  </Canvas>, */}
      <div className="Welcome">
        <h3> Hii! I'am Raj. Welcome to my Portfolio</h3>
        <div id="newClass"></div>

        <div>
          {/* <a href={Resume} download><button>Download Resume</button></a> */}
        </div>
      </div>
      {/* <Canvas>
        <ambientLight />
        <OrbitControls enableZoom={false}></OrbitControls>
        <Suspense fallback={null}>
          <Drone />
        </Suspense>
        <Environment preset="sunset"></Environment>
      </Canvas> */}
      <Footer></Footer>
    </div>
    </>
  );
}

export default App;
